module.exports = __webpack_public_path__ + "packs/media/images/pic02-2b07761921b40834e5bfd6bc753c1a8c.jpg";